module.exports = __webpack_public_path__ + "media/images/emblems/Rafz-blazon-acdaa8288f03eec2a80a20659fff3d58.svg";